import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppHeader from '../AppHeader';
import AppFooter from '../AppFooter';

import styles from './styles.scss';

class AppLayout extends React.Component {
  render() {
    return [
      <div
        key="main"
        className={classNames(styles.app, {
          [styles.login]: !this.props.isAuthenticated,
        })}
      >
        <AppHeader isAuthenticated={this.props.isAuthenticated} />
        {this.props.children}
      </div>,
      <AppFooter key="footer" />,
    ];
  }
}

AppLayout.propTypes = {
  isAuthenticated: PropTypes.bool,
  children: PropTypes.node,
};

export default AppLayout;



// WEBPACK FOOTER //
// src/components/layout/AppLayout/index.jsx